import React from 'react';
import { Tooltip, Icon } from 'antd';
import { useTranslation } from 'react-i18next';
import ContentsOfCampaignContainer from '../../containers/ContentsOfCampaignContainer';
import Colors from '../../../../../themes/Colors';

// Header del Panel 3
export const ContentsPanelHeader = ({ errors, cart, creationType, editCampaignActive }) => {
  const { t } = useTranslation();

  return (creationType && creationType === 'createCampaign') || editCampaignActive ? (
    <div>
      {t('Contents for the campaign')}
      {errors['contentsDisplays'] && (
        <Tooltip placement="bottomLeft" title={errors['contentsDisplays']}>
          <Icon style={{ marginLeft: '5px', fontSize: '16px', color: Colors.red }} type="warning" />
        </Tooltip>
      )}
    </div>
  ) : (
    <div>{`${t('Selected screens')} (${cart.length})`}</div>
  );
};

// Body del Panel 3
const ContentsPanel = ({ errors, currentCampaign }) => {
  const isPaymentStatusApproved = currentCampaign && currentCampaign.payment_status === 'approved';

  return (
    <ContentsOfCampaignContainer
      isPaymentStatusApproved={isPaymentStatusApproved}
      errors={errors}
    />
  );
};

export default ContentsPanel;
